import * as angular from 'angular';
import SessionTimeoutNotifierBridge from './bridges/SessionTimeoutNotifierBridge';

angular
  .module('flowingly.components')
  .component('sessionTimeoutNotifier', SessionTimeoutNotifierBridge);
